<!-- 人员信息组件 -->
<template>
  <div class="body">
    <span>
      <img v-if="userObj.img" :src="userObj.img" class="userAvator" alt />
      <span v-else class="avatortox">{{ userObj.tox }}</span>

      <el-popover trigger="hover" placement="right" width="400" @show="showPopover">
        <div>
          <el-descriptions class="margin-top" title="人员信息" :column="2" size="small" border>
            <el-descriptions-item v-if="userInfo.name">
              <template slot="label">
                用户名
              </template>
              {{ userInfo.name }}
            </el-descriptions-item>
            <el-descriptions-item v-if="userInfo.deptName">
              <template slot="label">
                部门名称
              </template>
              {{ userInfo.deptName }}
            </el-descriptions-item>
            <el-descriptions-item v-if="userInfo.deptManager">
              <template slot="label">
                部门领导
              </template>
              {{ userInfo.deptManager }}
            </el-descriptions-item>
            <el-descriptions-item v-if="userInfo.deptLeader">
              <template slot="label">
                部门经理
              </template>
              {{ userInfo.deptLeader }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <span slot="reference">{{ userObj.name }}</span>
      </el-popover>

      <span v-if="type===1" class="deleteBtn" @click="deleUser(userObj)">
        <i class="el-icon-delete hand delete" title="删除人员"></i>
      </span>
    </span>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { gettouxAvatar } from "@/CommonDP/utils";
export default {
  name: "",
  components: {},
  mixins: [],
  props: {
    obj: {
      type: Object,
      default: () => ({})
    },
    type: {
      // 0不可删 1可删
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      userObj: {}, // 人员
      userInfo: {} // 人员信息
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    })
  },
  watch: {},
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      if (this.obj.userId) {
        this.setUserObj(this.obj);
      }
    },
    // 返回人员列表
    getUserObj() {
      return this.userObj;
    },
    setUserObj(obj) {
      console.log(obj);
      const img = gettouxAvatar(obj.userId);
      if (img) {
        obj.img = img;
      } else {
        obj.tox = obj.name.charAt(0);
      }
      this.userObj = obj;
    },
    showPopover() {
      const inFo = {
        name: "klq",
        deptName: "产品研究院",
        deptManager: "刘晓东",
        deptLeader: "钟玉亮"
      };
      this.userInfo = inFo;
    },
    // 删除
    deleUser(obj) {
      this.$confirm(`此操作将删除人员 ${obj.name} , 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.userObj = {};
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>

<style scoped lang="scss">
.body {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .userAvator {
    border-radius: 50%;
    width: 16px;
    height: 18px;
    padding-bottom: 2px;
    margin-right: 0px;
    display: inline-block;
    vertical-align: middle;
  }

  .avatortox {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    line-height: 32px;
    margin: 0 auto;
    margin-right: 0px;
    border: 1px solid #4777e7;
    background: #4777e7;
    color: #fff;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
  }
  .hand {
    cursor: pointer;
  }
  .deleteBtn {
    margin-left: 5px;
  }
}
</style>
